import scroll2 from './scrollto';

class ScrollSpy {
  constructor(navSelector, options = {}) {
    this.nav = navSelector;
    this.links = this.nav.querySelectorAll('a');
    this.sections = [];

    this.initSections();

    const defaultOptions = {
      root: null,
      rootMargin: '0px',
      threshold: 0,
      offset: 0
    };

    this.options = Object.assign(defaultOptions, options);

    this.updateActiveLink = this.updateActiveLink.bind(this);
    window.addEventListener('scroll', this.updateActiveLink);
    window.addEventListener('resize', this.updateActiveLink);

    this.updateActiveLink();
  }

  initSections() {
    this.links.forEach((link) => {
      const section = document.querySelector(link.getAttribute('href'));
      if (section) {
        this.sections.push({ link, section });
      }
    });
  }

  updateActiveLink() {
    let activeLink = null;
    const offset = this.options.offset;

    this.sections.forEach(({ link, section }) => {
      const sectionTop = section.getBoundingClientRect().top;

      if (sectionTop <= offset) {
        activeLink = link;
      }
    });

    this.links.forEach((link) => link.classList.remove('active'));
    if (activeLink) {
      activeLink.classList.add('active');
    } else {
      this.links[0].classList.add('active');
    }
  }

  static init() {
    const scrollSpyNav = document.getElementById('scroll-spy-nav');
    if (!scrollSpyNav) return null;

    const spy = new ScrollSpy(scrollSpyNav, { offset: 115 });

    const s2 = scrollSpyNav.querySelectorAll('.scroll-to');
    if (s2.length > 0) {
      s2.forEach((link) => {
        link.addEventListener('click', (event) => {
          event.preventDefault();
          scroll2.scroll2(link);
        });
      });
    }

    return spy;
  }
}

export default ScrollSpy;
